import { TEMPLATE_ID_BASE_SHARED_STRUCTURE } from './templateConstants';

export const DEFAULT_ANLAGEBERATER_ETF = 'Shareholder Value Management AG';

export const DEFAULT_ANLAGEBERATER_WITH_TIED_AGENT =
  'Shareholder Value Management AG\nTied Agent der NFS Netfonds Financial Services GmbH';

/** ETF base structure (698422…) does not show Anlageberater on the factsheet. */
export function templateShowsAnlageberater(templateId?: string): boolean {
  return templateId !== TEMPLATE_ID_BASE_SHARED_STRUCTURE;
}

/** Non-ETF factsheets require the Tied-Agent compliance line under Anlageberater. */
export function templateUsesTiedAgentAnlageberater(templateId?: string): boolean {
  return !!templateId && templateId !== TEMPLATE_ID_BASE_SHARED_STRUCTURE;
}

export function normalizeMultilineFieldValue(value: unknown): string {
  if (value === undefined || value === null) return '';
  return String(value)
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .replace(/\n{2,}/g, '\n')
    .split('\n')
    .map((line) => line.replace(/\s+/g, ' ').trim())
    .filter((line) => line.length > 0)
    .join('\n');
}

/** Split a multiline field into display lines (no blank rows). */
export function splitMultilineFieldLines(value: unknown): string[] {
  const normalized = normalizeMultilineFieldValue(value).trim();
  if (!normalized) return [];
  return normalized.split('\n');
}

export function resolveAnlageberater(stored: unknown, templateId?: string): string {
  const trimmed = normalizeMultilineFieldValue(stored).trim();
  if (trimmed) return trimmed;
  if (templateUsesTiedAgentAnlageberater(templateId)) {
    return DEFAULT_ANLAGEBERATER_WITH_TIED_AGENT;
  }
  return DEFAULT_ANLAGEBERATER_ETF;
}
